<template>
  <div v-if="inputedValue.dialog && pageData.length > 0">
    <InfoDialogBase
      v-model="inputedValue"
      :width="width"
      :title="title"
      :pageData="pageData"
      :recItems="recItems"
      :isHistoryType="true"
      :isEdit="false"
      @updateRemarks="updateRemarks"
    >
      <template v-slot:[pageData[1].buttonAreaName]>
        <NormalButton
          v-show="authority.isAdmin"
          :text="`${pageType.ja}` + $t('user.user_cancel')"
          height="32px"
          color="white"
          textColor="thinText--text"
          class="pa-2 mx-1"
          btnClass="px-3"
          :outlined="true"
          @click="cancel"
        />
        <NormalButton
          :text="`${pageType.ja}` + $t('common.input_fix')"
          height="32px"
          color="white"
          textColor="thinText--text"
          class="pa-2 mx-1"
          btnClass="px-3"
          :outlined="true"
          @click="edit"
        />
      </template>
      <template v-slot:[pageData[3].name]>
        <slot name="loadingHistoryList" v-bind:item="loadingHistoryListInfo" />
      </template>
      <template
        v-if="authority.isAdmin || authority.isUser"
        v-slot:[pageData[4].name]="{ item }"
      >
        <PaymentTable
          :item="item"
          :unitName="unitName"
          paymentType="order"
          :isOperation="false"
        />
      </template>
      <template v-slot:[pageData[getChangeHistoryIndex].name]>
        <slot name="changeHistoryList" v-bind:item="changeHistoryListInfo" />
      </template>
    </InfoDialogBase>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { productMovesUtil, orderUtil, currencyUtil } from '@/util'
import orderHeadersHistory from '@/views/order/History/headers'

import InfoDialogBase from './OrderInfoDialogBase'

import headers from '@/views/order/History/headers'
import headersLoading from '@/views/order/Loading/headers'

import NormalButton from '@/components/items/Buttons/NormalButton'
import PaymentTable from '@/components/items/Tables/PaymentTable'

export default {
  components: {
    InfoDialogBase,
    NormalButton,
    PaymentTable
  },
  props: {
    value: { default: false },
    width: { default: '540px' },
    title: { default: '' },
    recItems: {
      type: Object,
      require: true,
      default: () => ({})
    }
  },
  data: () => ({
    pageData: [],

    pageType: {
      en: 'order',
      ja: '発注'
    },

    loadingHistoryListInfo: {
      historyList: [],
      headers: headersLoading.headers,
      tableKey: headersLoading.tableKey,
      productListHeaders: headersLoading.productListHeaders
    },
    changeHistoryListInfo: {
      historyList: [],
      headers: [
        {
          text: 'common.common_fix-date',
          value: 'loadingDate',
          width: '100px'
        },
        {
          text: 'common.common_fix-user',
          value: 'loadingName',
          width: '80px'
        }
      ],
      tableKey: 'changeId',
      productListHeaders: headers.productListHeaders
    },

    unitName: ''
  }),
  // created() {
  //   this.ini()
  // },
  methods: {
    ...mapActions('Loading', ['getLoadingListFromApi']),
    ...mapActions('Order', [
      'getOrderPaymentListFromApi',
      'cancelOrder',
      'editOrderNote',
      'getOrderDetailListFromApi'
    ]),
    ...mapActions('Common', ['setIsLoading']),

    getAmount1() {
      // 合計金額
      return '12, 600'
    },
    getAmount1Unit() {
      // 合計金額 単位
      return '元'
    },
    getAmount2() {
      // 未出金金額
      return '5,000'
    },
    getAmount2Unit() {
      // 合計金額 単位
      return '元'
    },
    edit() {
      const nameTmp = this.pageType.en + '.edit'
      this.$router.push({
        name: nameTmp,
        params: {
          selectItems: this.recItems
        }
      })
    },

    getAmount() {
      // 合計金額
      return orderUtil.calcOrderAmountById(this.recItems.orderId)
    },
    getPayAmount(paymentList) {
      // 出金済金額
      return paymentList.data.reduce((sum, ele) => {
        return sum + Number(ele.amount)
      }, 0)
    },

    getTotalAmount(param) {
      const type = 'order'
      const productListHeaders = orderHeadersHistory.productListHeaders

      // 発注で履歴に設定された通貨が日本円の場合は各消費税の小計に加える
      let totalAmountAndUnitTaxFree = 0
      if (param.currencyId !== 1) {
        totalAmountAndUnitTaxFree = productMovesUtil.getTotalAmountAndUnit(
          param.orderEditHistoryProduct,
          param.currencyId
        )
      } else {
        totalAmountAndUnitTaxFree = productMovesUtil.getTotalAmountAndUnit(
          param.orderEditHistoryProduct.filter((ele) => ele.exportSubjectFlg),
          param.currencyId
        )
      }

      let totalAmountTax10 = 0
      let totalAmountTax8 = 0
      if (param.currencyId !== 1) {
        totalAmountTax10 = productMovesUtil.getTotalAmount(
          param.orderEditHistoryProduct.filter((ele) => ele.product.taxId === 2)
        )
        totalAmountTax8 = productMovesUtil.getTotalAmount(
          param.orderEditHistoryProduct.filter((ele) => ele.product.taxId === 1)
        )
      } else if (!this.isOrder) {
        totalAmountTax10 = productMovesUtil.getTotalAmount(
          param.orderEditHistoryProduct.filter(
            (ele) => !ele.exportSubjectFlg && ele.product.taxId === 2
          )
        )
        totalAmountTax8 = productMovesUtil.getTotalAmount(
          param.orderEditHistoryProduct.filter(
            (ele) => !ele.exportSubjectFlg && ele.product.taxId === 1
          )
        )
      }
      const totalAmountTax10OnlyTax = param.consumptionTax10
      const totalAmountTax8OnlyTax = param.consumptionTax8

      const totalAmount = orderUtil[
        `calc${type.charAt(0).toUpperCase()}${type.slice(1)}AmountById`
      ](param[`${type}Id`])

      return {
        taxFree: totalAmountAndUnitTaxFree.amount,
        tax10: {
          totalAmount: totalAmountTax10,
          tax: totalAmountTax10OnlyTax
        },
        tax8: {
          totalAmount: totalAmountTax8,
          tax: totalAmountTax8OnlyTax
        },
        discount: this.recItems.discount,
        shipping: this.recItems.comission,
        totalAmount: totalAmount,
        unitName: totalAmountAndUnitTaxFree.unit,
        currencyId: param.currencyId
      }
    },
    async ini() {
      this.unitName = currencyUtil.findCurrencyNameById(
        this.recItems.currencyId
      ).unitName

      // loading History
      const loadingList = await this.getLoadingListFromApi({
        orderControlNumber: this.recItems.transaction.controlNumber,
        invalidLoadingDisplay: 0
      })
      const format = loadingList.data.map((ele, Index) => {
        ele.panelIndex = Index + 1
        return ele
      })
      this.loadingHistoryListInfo.historyList = format

      // change history
      const orderIds = String(this.recItems.orderId)
      const orderDetailList = await this.getOrderDetailListFromApi({
        orderIds
      })
      const changeHistoryFormat =
        orderDetailList.data[0].orderEditHistoryList.map((ele, Index) => {
          return {
            changeId: ele.orderEditHistoryId,
            loadingDate: ele.createdAt.split(' ')[0],
            loadingName: ele.user.lastName + ele.user.firstName,
            panelIndex: Index + 1,
            totalList: this.getTotalAmount(ele),
            ...ele
          }
        })
      this.changeHistoryListInfo.historyList = changeHistoryFormat

      // payment History
      const paymentList =
        this.authority.isAdmin || this.authority.isUser
          ? await this.getOrderPaymentListFromApi({
              id: this.recItems.orderId
            })
          : { data: [] }

      const amount = this.getAmount()
      const payAmount = this.getPayAmount(paymentList)
      const notPayAmount = amount - payAmount

      this.pageData = [
        {
          title: 'order.order_supplier-info',
          name: 'spplierInfo',
          items: [],
          itemKey: ''
        },
        {
          title: 'order.order_order-detail',
          name: 'operationDetail',
          buttonAreaName: 'operationDetailbuttonArea',
          headers: headers.productListHeaders,
          items: [],
          footers: [],
          itemKey: this.recItems.orderId
        },
        {
          title: 'sale.sale_note',
          name: 'test1',
          items: [],
          itemKey: ''
        },
        {
          title: 'loading.loading_receipt-history',
          name: 'loadingHistory',
          items: [],
          itemKey: ''
        },
        {
          title: 'sale.sale_payment-history',
          name: 'paymentHistory',
          buttonName: 'sale.sale_payment-cancellation',
          itemKey: 'orderPaymentId',
          headers: [
            {
              text: 'storage.storage_payment-date',
              value: 'date',
              sortable: false,
              width: '12%'
            },
            {
              text: 'storage.storage_payment-price',
              value: 'amount',
              sortable: false,
              width: '12%',
              align: 'end'
            },
            {
              text: 'storage.storage_payment-method',
              value: 'paymentMethodId',
              sortable: false,
              width: '12%'
            },
            {
              text: 'payment.payment_operation',
              value: 'operationId',
              sortable: false
            }
          ],
          items: paymentList.data,
          footers: [
            {
              name: 'storage.storage_already-payment-price-no-colon',
              data: payAmount
            },
            {
              name: 'payment.payment_total-price-no-colon',
              data: amount
            },
            {
              name: 'storage.storage_not-payment-price',
              data: notPayAmount
            }
          ]
        },
        {
          title: 'common.common_fix-history',
          name: 'changeHistory',
          items: [],
          itemKey: ''
        }
      ]

      // 権限がない場合は出金履歴をテーブルから除外
      if (!this.authority.isAdmin && !this.authority.isUser) {
        this.pageData = this.pageData.filter((table) => {
          return table.name !== 'paymentHistory'
        })
      }
    },
    register() {
      alert('register')
      this.inputedValue = false
    },
    async cancel() {
      if (
        !confirm(`
${this.$t('order.order_restore-order-confirm')}

${this.$t('order.order_irreversible-confirm')}`)
      )
        return
      this.setIsLoading(true)
      const isSucceed = await this.cancelOrder({ id: this.recItems.orderId })
      if (isSucceed) {
        alert(this.$t('common.common_canceled-alert'))
        this.inputedValue.dialog = false
        this.$emit('complete')
      }
      this.setIsLoading(false)
    },
    async updateRemarks(...args) {
      const [remarks, type] = args
      let hasConfirm = false
      const params = { id: this.recItems.orderId }
      if (type === 'private') {
        hasConfirm = confirm(`${this.$t(
          'common.common_confirm-to-save-remarks'
        )}
${this.$t('sale.sale_only-open-to-internal-members')}`)
        params.note = remarks
      } else if (type === 'client') {
        hasConfirm = confirm(`${this.$t(
          'common.common_confirm-to-save-remarks'
        )}
${this.$t('sale.sale_public-information-stated')}`)
        params.orderNote = remarks
      }

      if (!hasConfirm) return
      const isSuccess = await this.editOrderNote(params)

      if (!isSuccess) return
      alert(this.$t('common.common_saved-alert'))
      this.ini()
    }
  },
  computed: {
    ...mapGetters('User', ['authority']),
    inputedValue: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      }
    },
    getChangeHistoryIndex() {
      return this.authority.isAdmin || this.authority.isUser ? 5 : 4
    }
  },
  watch: {
    'inputedValue.dialog': async function (val) {
      val ? await this.ini() : null
    }
  }
}
</script>
<style lang="scss" scoped></style>
